import React from 'react'
import { Switch, Route } from 'react-router'
import { Chart } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

import { ACL } from '../constants'
import routes from '../constants/routes'
import Logs from './ActionLogs'
import Configure from './Configure'
import Content, { Channels, Layers, Media, RenderTool, Playlists } from './Content'
import MediaDetails from './Content/Media/MediaDetails'
import ContentPush, { ContentPushForm } from './ContentPush'
import ErrorPage from './ErrorPage'
import { EstateList, Store } from './Estate'
import Login from './Login'
import Landing from './Landing/Landing'
import LoginCallback from './LoginCallback'
import PrivateRoute from './PrivateRoute'
import ReportingDashboards from './ReportingDashboards'
import Reports from './Reports'
import RootPage from './RootPage'
import SelfServe from './SelfServe'
import SetupDevice from './SetupDevice'
import Statistics from './Statistics'
import OperationsHub from './OperationsHub'

// Register the plugin to all charts:
Chart.register(ChartDataLabels)

const App = () => (
    <React.Fragment>
        <Switch>
            <PrivateRoute exact path={routes['CONTENT:CHANNELS']} component={Channels} acls={[ACL.VIEW_CONTENT]} />
            <PrivateRoute exact path={routes['CONTENT:LAYERS']} component={Layers} acls={[ACL.VIEW_CONTENT]} />
            <PrivateRoute exact path={routes['CONTENT:MEDIA:DETAILS']} component={MediaDetails} acls={[ACL.VIEW_CONTENT]} />
            <PrivateRoute exact path={routes['CONTENT:MEDIA']} component={Media} acls={[ACL.VIEW_CONTENT]} />
            <PrivateRoute exact path={routes['CONTENT:PLAYLISTS']} component={Playlists} acls={[ACL.VIEW_CONTENT]} />
            <PrivateRoute exact path={routes.CONTENT} component={Content} acls={[ACL.VIEW_CONTENT]} />
            <PrivateRoute exact path={routes.CONTENT_PUSH} component={ContentPush} acls={[ACL.VIEW_CONTENT]} />
            <PrivateRoute path={routes.CONTENT_PUSH_FORM} component={ContentPushForm} acls={[ACL.VIEW_CONTENT]} />
            <PrivateRoute exact path={routes['ESTATE:LIST']} component={EstateList} acls={[ACL.VIEW_ESTATE_LIST]} />
            <PrivateRoute exact path={routes['ESTATE:STORE:ID']} component={Store} acls={[ACL.VIEW_ESTATE_LIST]} />
            <PrivateRoute exact path={routes['ESTATE:STORE:ID:SEARCH']} component={Store} acls={[ACL.VIEW_ESTATE_LIST]} />
            <PrivateRoute exact path={routes['STATISTICS:HOURS']} component={Statistics} />
            {/* <PrivateRoute exact path={routes.DASHBOARD} component={Dashboard} /> */}
            <Route path={routes['LOGIN:SESSION']} component={Login} />
            <Route path={routes['LOGIN:CALLBACK']} component={LoginCallback} />
            <Route path={routes.SETUP} component={SetupDevice} />
            <PrivateRoute exact path={routes.CONFIGURE} component={Configure} acls={[ACL.VIEW_CONFIGURE]} noEstate />
            <PrivateRoute exact path={routes.LOGS} component={Logs} acls={[ACL.VIEW_LOGS]} />
            <PrivateRoute exact path={routes.ERROR} component={ErrorPage} />
            <PrivateRoute
                exact
                path={routes.RENDER}
                component={RenderTool}
                acls={[
                    {
                        acl: ACL.VIEW_ADCREATE,
                        ignoreAdmin: true,
                    },
                ]}
            />
            <PrivateRoute exact path={routes.REPORTS} component={Reports} acls={[ACL.VIEW_REPORTS]} />
            <PrivateRoute exact path={routes.REPORTING_DASHBOARDS} component={ReportingDashboards} acls={[ACL.VIEW_REPORTS]} />
            {/* TODO: Add ALC for accessing Self Serve */}
            <PrivateRoute exact path={routes.SELF_SERVE} component={SelfServe} acls={[]} />
            <PrivateRoute exact path={routes.OPERATIONS_HUB} component={OperationsHub} acls={[]} />
            <PrivateRoute path={routes.LANDING} component={Landing} />
            <PrivateRoute path={routes.ROOT} component={RootPage} />
        </Switch>
    </React.Fragment>
)

export default App
